import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedTime from '../FormattedTime';
import CroppedImage from '../CroppedImage';

export default class RecommendedCouponListItem extends Component {

  constructor() {
    super();

    this.replaceToCustomScheme = this.replaceToCustomScheme.bind(this);
    this.getDDay = this.getDDay.bind(this);
    this.getDimmedType = this.getDimmedType.bind(this);
  }

  replaceToCustomScheme(permalink) {
    const { coupon } = this.props;

    // FROM - permalink : http://sandbox-pf.kakao.com/_jlM/coupons/_VZo51n
    // TO - customScheme : alphaplus://plusfriend/coupon/_vdV/_Kgo51n
    let temp = "";
    if (permalink.match('sandbox-')) {
      temp += "alphaplus://plusfriend/coupon/"
    } else {
      temp += "kakaoplus://plusfriend/coupon/"
    }

    const profileId = permalink.split('/')[3];
    const couponId = permalink.split('/')[5];
    return temp + coupon.profileId + "/" + coupon.id;
  }

  getDDay(entryEndAt) {
    const result = entryEndAt - (new Date());
    return Math.floor(result / (86400 * 1000))
  }

  getDimmedType() {
    const { showUsed, showOutdated } = this.props;

    if (showUsed) {
      return "used";
    } else if (showOutdated) {
      return "outDated";
    }
    return "";
  }

  render() {
    const { coupon } = this.props;

    return (
      <li>
        <a href={this.replaceToCustomScheme(coupon.permalink)} className="link_coupon">
          <div className="item_coupon" role="text">
            <CroppedImage src={coupon.entryImage.mediumUrl} className="thumb_coupon"
                          alt={coupon.title} dimmed={this.getDimmedType()} />
            <div className="info_coupon">
              <strong className="tit_coupon"> {coupon.author.nickname} </strong>
              <span className="txt_coupon"> {coupon.title} </span>
            </div>
          </div>
          <div className="date_coupon">
              <span className="txt_date">
                <span>응모기간 : <FormattedTime value={coupon.entryStartAt} tz="Asia/Seoul"/>
                    &nbsp;~ <FormattedTime value={coupon.entryEndAt} tz="Asia/Seoul"/> 까지
                </span>
              </span>
            <span className="txt_day txt_before">
              {this.getDDay(coupon.entryEndAt) === 0 ? '오늘' : `D-${this.getDDay(coupon.entryEndAt)}`}
            </span>
          </div>
        </a>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RecommendedCouponListItem/index.js